var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"campaign-status"},[(_vm.statusLabel)?_c('div',{class:_vm.statusLabel.textClass},[_vm._l((_vm.statusLabel.lines),function(line,index){return [(index > 0)?_c('br',{key:index}):_vm._e(),_vm._v("\n      "+_vm._s(line)+"\n    ")]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }